import React from "react";
import { IntroPage } from "@src/components/page-template/IntroPage";
import { useSearchParams } from "react-router-dom";

export const ContentsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeScreen = searchParams.get("screen") ?? undefined;
  const setActiveScreen = (id: string): void => setSearchParams({ screen: id });

  return <IntroPage onScreenSelect={setActiveScreen} activeScreen={activeScreen} />;
};
